document.addEventListener(
    'DOMContentLoaded',
    () => {
        const panel = document.querySelector(
            '[data-message-search]'
        );

        const toggle = document.querySelector(
            '[data-message-search-toggle]'
        );

        if (!panel || !toggle) {
            return;
        }

        const input = panel.querySelector(
            '[data-message-search-input]'
        );

        const close = panel.querySelector(
            '[data-message-search-close]'
        );

        const status = panel.querySelector(
            '[data-message-search-status]'
        );

        const results = panel.querySelector(
            '[data-message-search-results]'
        );
        const messageList = document.querySelector(
            '[data-message-list]'
        );

        const insertionPoint = messageList?.querySelector(
            '[data-message-insertion-point]'
        );

        const historyBanner =
            document.querySelector(
                '[data-history-banner]'
            );

        const returnButton =
            document.querySelector(
                '[data-return-current]'
            );

        const searchUrl =
            panel.dataset.searchUrl;
        const contextUrlTemplate =
            panel.dataset.contextUrlTemplate;
        const currentMessagesUrl =
            panel.dataset.currentUrl;

        if (
            !input
            || !close
            || !status
            || !results
            || !messageList
            || !insertionPoint
            || !searchUrl
            || !contextUrlTemplate
        ) {
            return;
        }

        let debounceTimeout = null;
        let activeController = null;
        let viewingHistory = false;

        const createMessageElement = (html) => {
            const template =
                document.createElement('template');

            template.innerHTML =
                html.trim();

            return template.content
                .firstElementChild;
        };

        const replaceMessages = (messages) => {
            messageList
                .querySelectorAll(
                    '[id^="message-"]'
                )
                .forEach((message) => {
                    message.remove();
                });

            messages.forEach((message) => {
                if (
                    typeof message.html
                    !== 'string'
                ) {
                    return;
                }

                const messageElement =
                    createMessageElement(
                        message.html
                    );

                if (!messageElement) {
                    return;
                }

                messageList.insertBefore(
                    messageElement,
                    insertionPoint
                );
            });
        };

        const clearHighlight = () => {
            document
                .querySelectorAll(
                    '[data-message-search-highlight]'
                )
                .forEach((element) => {
                    element.classList.remove(
                        'ring-2',
                        'ring-cyan-300',
                        'ring-offset-4',
                        'ring-offset-slate-950'
                    );

                    delete element.dataset
                        .messageSearchHighlight;
                });
        };

        const highlightMessage = (message) => {
            clearHighlight();

            message.dataset
                .messageSearchHighlight = '';

            message.classList.add(
                'ring-2',
                'ring-cyan-300',
                'ring-offset-4',
                'ring-offset-slate-950'
            );

            const bannerHeight =
                historyBanner?.offsetHeight ?? 0;

            const top =
                message.getBoundingClientRect().top
                + window.scrollY
                - bannerHeight
                - 30;

            window.scrollTo({
                top,
                behavior: 'smooth',
            });

            window.setTimeout(
                clearHighlight,
                2500
            );
        };

        const loadMessageContext = async (
            messageId
        ) => {
            const contextUrl =
                contextUrlTemplate.replace(
                    '__MESSAGE__',
                    String(messageId)
                );

            status.textContent =
                'Loading message context…';

            const response = await fetch(
                contextUrl,
                {
                    credentials:
                        'same-origin',

                    headers: {
                        Accept:
                            'application/json',

                        'X-Requested-With':
                            'XMLHttpRequest',
                    },
                }
            );

            const data =
                await response.json()
                    .catch(
                        () => ({})
                    );

            if (!response.ok) {
                throw new Error(
                    'The message context could not be loaded.'
                );
            }

            if (
                !Array.isArray(data.messages)
            ) {
                throw new Error(
                    'The server returned an invalid context response.'
                );
            }

            if (data.messages.length === 0) {
                throw new Error(
                    'No message context was returned.'
                );
            }

            replaceMessages(
                data.messages
            );

            const targetMessage =
                document.getElementById(
                    `message-${data.target_id}`
                );

            if (!targetMessage) {
                throw new Error(
                    'The matching message could not be displayed.'
                );
            }

            status.textContent =
                'Showing the matching message with nearby context.';

            highlightMessage(
                targetMessage
            );
            viewingHistory = true;

            historyBanner?.classList.remove(
                'hidden'
            );

            window.dispatchEvent(
                new CustomEvent(
                    'conversation-history-mode',
                    {
                        detail: {
                            active: true,
                        },
                    }
                )
            );
        };

        const resetSearch = () => {
            if (debounceTimeout) {
                window.clearTimeout(
                    debounceTimeout
                );
            }

            activeController?.abort();
            activeController = null;

            input.value = '';
            status.textContent = '';
            results.innerHTML = '';
            results.classList.add('hidden');

            clearHighlight();
        };

        const formatDate = (value) => {
            const date = new Date(value);

            if (
                Number.isNaN(
                    date.getTime()
                )
            ) {
                return '';
            }

            return date.toLocaleString(
                undefined,
                {
                    dateStyle: 'medium',
                    timeStyle: 'short',
                }
            );
        };

        const createResult = (
            result
        ) => {
            const button =
                document.createElement('button');

            button.type = 'button';

            button.className =
                'block w-full rounded-xl '
                + 'border border-white/10 '
                + 'bg-white/5 px-4 py-3 '
                + 'text-left transition '
                + 'hover:border-cyan-400/30 '
                + 'hover:bg-cyan-400/10';

            const header =
                document.createElement('div');

            header.className =
                'flex flex-wrap items-center '
                + 'justify-between gap-2';

            const sender =
                document.createElement('span');

            sender.className =
                'text-sm font-black text-white';

            sender.textContent =
                result.sender ?? 'Member';

            const timestamp =
                document.createElement('span');

            timestamp.className =
                'text-xs text-slate-400';

            timestamp.textContent =
                formatDate(
                    result.created_at
                );

            const body =
                document.createElement('p');

            body.className =
                'mt-2 line-clamp-2 '
                + 'text-sm text-slate-300';

            body.textContent =
                result.body ?? '';

            header.append(
                sender,
                timestamp
            );

            button.append(
                header,
                body
            );

            button.addEventListener(
                'click',
                async () => {
                    clearHighlight();

                    let message =
                        document.getElementById(
                            `message-${result.id}`
                        );

                    if (message) {
                        highlightMessage(
                            message
                        );

                        return;
                    }

                    button.disabled = true;

                    const originalOpacity =
                        button.style.opacity;

                    button.style.opacity = '0.6';

                    try {
                        await loadMessageContext(
                            result.id
                        );
                    } catch (error) {
                        status.textContent =
                            error instanceof Error
                                ? error.message
                                : 'The message could not be loaded.';
                    } finally {
                        button.disabled = false;

                        button.style.opacity =
                            originalOpacity;
                    }
                }
            );

            return button;
        };

        const performSearch = async () => {
            const query =
                input.value.trim();

            activeController?.abort();

            if (query.length < 2) {
                status.textContent =
                    query.length === 1
                        ? 'Enter at least 2 characters.'
                        : '';

                results.innerHTML = '';
                results.classList.add(
                    'hidden'
                );

                return;
            }

            const controller =
                new AbortController();

            activeController =
                controller;

            status.textContent =
                'Searching…';

            try {
                const url =
                    new URL(
                        searchUrl,
                        window.location.origin
                    );

                url.searchParams.set(
                    'q',
                    query
                );

                const response =
                    await fetch(
                        url,
                        {
                            credentials:
                                'same-origin',

                            signal:
                            controller.signal,

                            headers: {
                                Accept:
                                    'application/json',

                                'X-Requested-With':
                                    'XMLHttpRequest',
                            },
                        }
                    );

                const data =
                    await response.json()
                        .catch(
                            () => ({})
                        );

                if (!response.ok) {
                    throw new Error(
                        'Search could not be completed.'
                    );
                }

                const searchResults =
                    Array.isArray(
                        data.results
                    )
                        ? data.results
                        : [];

                results.innerHTML = '';

                if (
                    searchResults.length === 0
                ) {
                    status.textContent =
                        'No matching messages found.';

                    results.classList.add(
                        'hidden'
                    );

                    return;
                }

                searchResults.forEach(
                    (result) => {
                        results.append(
                            createResult(
                                result
                            )
                        );
                    }
                );

                status.textContent =
                    `${searchResults.length} `
                    + (
                        searchResults.length === 1
                            ? 'match'
                            : 'matches'
                    );

                results.classList.remove(
                    'hidden'
                );
            } catch (error) {
                if (
                    error instanceof DOMException
                    && error.name === 'AbortError'
                ) {
                    return;
                }

                status.textContent =
                    error instanceof Error
                        ? error.message
                        : 'Search could not be completed.';

                results.innerHTML = '';
                results.classList.add(
                    'hidden'
                );
            } finally {
                if (
                    activeController
                    === controller
                ) {
                    activeController = null;
                }
            }
        };

        toggle.addEventListener(
            'click',
            () => {
                panel.classList.remove(
                    'hidden'
                );

                input.focus();
            }
        );

        close.addEventListener(
            'click',
            () => {
                resetSearch();

                panel.classList.add(
                    'hidden'
                );
            }
        );

        input.addEventListener(
            'input',
            () => {
                if (debounceTimeout) {
                    window.clearTimeout(
                        debounceTimeout
                    );
                }

                debounceTimeout =
                    window.setTimeout(
                        performSearch,
                        300
                    );
            }
        );

        returnButton?.addEventListener(
            'click',
            async () => {
                status.textContent =
                    'Returning to live conversation…';

                const response =
                    await fetch(
                        currentMessagesUrl,
                        {
                            credentials:
                                'same-origin',

                            headers: {
                                Accept:
                                    'application/json',

                                'X-Requested-With':
                                    'XMLHttpRequest',
                            },
                        }
                    );

                const data =
                    await response.json();

                replaceMessages(
                    data.messages
                );

                messageList.dataset
                    .latestMessageId =
                    data.latest_id;

                viewingHistory = false;

                historyBanner
                    ?.classList.add(
                    'hidden'
                );

                window.dispatchEvent(
                    new CustomEvent(
                        'conversation-history-mode',
                        {
                            detail: {
                                active: false,
                            },
                        }
                    )
                );

                insertionPoint.scrollIntoView({
                    behavior: 'smooth',
                    block: 'end',
                });

                status.textContent = '';
            }
        );

        input.addEventListener(
            'keydown',
            (event) => {
                if (
                    event.key !== 'Escape'
                ) {
                    return;
                }

                resetSearch();

                panel.classList.add(
                    'hidden'
                );

                toggle.focus();
            }
        );
    }
);